import { connectFela } from '../../dependencies';
import UserProfile from './UserProfile';
import * as styles from './UserProfile.styles';

export default connectFela(styles)(UserProfile);
